<template>
    <!-- What an epigenetics profile can't have, as it's made from the DNA an ancestry kit reads: in
         place of buying it, a profile with an ancestry kit to switch to, or the way to get one -->
    <UpgradePrompt v-if="hasAncestryKit" :title="`${product} needs an ancestry kit`" action="Change profile"
        @action="componentsStore.openChangeProfileModal()">
        It's made from the DNA an ancestry kit reads. Switch to a profile with an ancestry kit to add it there.
    </UpgradePrompt>
    <UpgradePrompt v-else :title="`${product} needs an ancestry kit`" action="Explore ancestry kits"
        :to="{ name: 'HealthStore', query: { tab: 'ancestrykits' } }">
        It's made from the DNA an ancestry kit reads, so it can't be added to an epigenetics kit. Get an ancestry
        kit, <router-link :to="{ name: 'profile-activate-dna-kit' }">activate one</router-link> you have, or
        <router-link :to="{ name: 'profile-who-does-this-dna-belong-to' }">upload DNA</router-link> you've tested
        elsewhere.
    </UpgradePrompt>
</template>

<script setup>
import { computed, defineProps } from "vue";
import store from "@/store";
import UpgradePrompt from "@/components/store/UpgradePrompt.vue";
import { useComponentsStore } from "@/store/modules/components";

defineProps({
    // What can't be had, e.g. "Wellbeing"
    product: { type: String, default: "This upgrade" },
});

const componentsStore = useComponentsStore();

// Another profile on the account with an ancestry kit or upload, as the Wellbeing page looks for
const hasAncestryKit = computed(() => (store.getters.accountTests ?? []).some((test) => !test.barcode?.endsWith("E")));
</script>
